import BaseUpdateRequest from "@/models/Shared/BaseUpdateRequest";

export default class UpdateBookingRoleRequest extends BaseUpdateRequest {
    ownerId: string;
    contactId: string;
    positionId: string;
    positionDescription: string;
    chargeRate = 0;
    deskId: string;
    uniformId: string;
    uniformDescription: string;
    skillIds: string[] = [];
    qualificationIds: string[] = [];
}